import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatMenu, MatMenuTrigger } from '@angular/material';
import { CreateTripCommand, TripStorageCommand } from '../../../../commands/visitor/create.trip.command';
import { MatFieldComponent } from '../../../../common/components';
import { ImageService } from '../../../../services/image.service';
import { LocalStorageService } from '../../../../services/localStorageService';
import { guid } from '../../../../utils/guid';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { SocialLoginPopupComponent } from '../../../../common/components/social.login.popup/social.login.popup.component';
import { clone } from '../../../../common/extensions';
import { VisitorTripNotifyAddOrRemoveItemStore } from '../../../../stores/visitor.calendar.store';
import { config } from '../../../../../config/config';
import { GlobalEventEmitter } from '../../../../common/services/global.event.emitter';
import { BaseComponent } from '../../../../common/components/base.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ig-add-to-trip-menu',
  templateUrl: './visitor.trip.add.to.trip.menu.component.html',
  styleUrls: ['./visitor.trip.add.to.trip.menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorTripAddToTripMenuComponent extends BaseComponent implements OnInit {
  @Input() public hubName: string;
  @Input() public isShow = true;
  @Input() public item: any;
  @Input() public isUserloggedIn = false;
  @Input() public inTripText = 'in my trip';
  @Input() public addToTripText = 'add to my trip';
  @Input() public bgColor = '#5cbcff';
  // @Input() public trips = [];
  // @Input() public menuTrigger: any;
  public type = 'event';
  public trips = [];
  public isAddingSuccess = [];
  public inTripStatus = [];
  public isAddingNewTrip = false;
  public isInAnyTrip = false;
  public newTripTitle = '';
  public tripFormGroup: FormGroup;
  @ViewChild('menuTrigger') public menuTrigger: MatMenuTrigger;
  @ViewChild('description') description: ElementRef;
  @ViewChild('tripTitle') public tripTitle: MatFieldComponent;
  @ViewChild('actionMenu') public actionMenu: MatMenu;
  @Output() onAddToTrip: EventEmitter<any> = new EventEmitter();
  @Output() onRemoveFromTrip: EventEmitter<any> = new EventEmitter();
  @Output() onAddNewTrip: EventEmitter<any> = new EventEmitter();
  @Output() onAddFirstTrip: EventEmitter<any> = new EventEmitter();

  constructor(
    public visitorApiService: VisitorApiService,
    private formBuilder: FormBuilder,
    private notifyAddOrRemoveItemStore: VisitorTripNotifyAddOrRemoveItemStore,
    private activatedRoute: ActivatedRoute,
    public imageService: ImageService
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    // let {hubName, tripId} = this.allRouteParams;
    // this.hubName = hubName;
    this.type = this.getItemType();
    this.trips = this.loadTripsInLocalStorage();
    this.getInTripStatus(this.trips);
    this.checkIsInAnyTrip();
    this.tripFormGroup = this.formBuilder.group({
      tripTitle: [null, [Validators.required]],
    });

    this.notifyAddOrRemoveItemStore.notifyCommand.takeUntil(this.isDestroyed).subscribe((item) => {
      this.checkIsInAnyTrip();
    });
  }

  public getInTripStatus(trips?) {
    this.inTripStatus = [];

    if (!trips) {
      trips = this.loadTripsInLocalStorage();
    }
    if (!trips || !trips.length) {
      return null;
    }

    trips.forEach((trip) => {
      let isInTrip = trip.attractions.any((x) => x.item.id === this.item.id);
      this.inTripStatus.push(isInTrip);
    });
  }

  public exitAddingNewTrip($event) {
    $event && $event.stopPropagation();
    this.isAddingNewTrip = false;
  }

  public saveNewTrip() {
    //this.onAddNewTrip.emit({title: this.newTripTitle, item: this.item, type: this.type});
    this.createNewTrip(this.newTripTitle, this.item, this.type);
    this.menuTrigger.closeMenu();
    this.newTripTitle = '';
    this.isAddingNewTrip = false;
  }

  public newTripFieldFocus($event) {
    $event.stopPropagation();
  }

  public addOrRemoveFromTrip($event, tripIndex) {
    $event.stopPropagation();
    if (this.inTripStatus[tripIndex]) {
      this.removeFromTrip(this.item._id, tripIndex);
    } else {
      this.addItemToTrip(this.item, this.type, this.item._id, tripIndex);
    }
    this.showAddingToTripSuccess(tripIndex);
    this.checkIsInAnyTrip();
    this.notifyAddOrRemoveItemStore.notifyCommand.next(null);
  }

  public addItemToTrip(item, type, feedId, tripIndex) {
    if (SocialLoginPopupComponent.isUserLoggedIn) {
      this.visitorApiService
        .addAtractionToTrip(this.hubName, {
          feedType: type,
          feedId: feedId,
          userFacebookId: SocialLoginPopupComponent.userId,
          tripIndex: tripIndex,
        })
        .subscribe();
    }
    this.addToLocalStorage(item, tripIndex);
  }

  public removeFromTrip(id, tripIndex?) {
    if (id) {
      if (SocialLoginPopupComponent.isUserLoggedIn) {
        this.removeTripItemFromDB(id, tripIndex);
      }
      this.removeFromLocalStorage(id, tripIndex);
    }
  }

  public removeFromLocalStorage(id, tripIndex?) {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(
      this.hubName,
      SocialLoginPopupComponent.userId
    );
    let trip = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;

    if (!trip || !trip.trips || trip.trips.length <= tripIndex) {
      return;
    }

    if (trip.trips[tripIndex] && trip.trips[tripIndex].attractions.length) {
      let index = trip.trips[tripIndex].attractions.getElementIndex((x) => x.feedId === id);
      trip.trips[tripIndex].attractions.splice(index, 1);
    }
    trip.trips[tripIndex].attractions = trip.trips[tripIndex].attractions.removeDuplicate();
    trip.timestamp = new Date();
    localStorage.setItem(key, JSON.stringify(trip));
    localStorage.setItem(keyWithUserID, JSON.stringify(trip));

    this.trips = trip.trips;
  }

  private removeTripItemFromDB(id, tripIndex) {
    this.visitorApiService
      .removeAtractionFromTrip(this.hubName, {
        feedId: id,
        userFacebookId: SocialLoginPopupComponent.userId,
        tripIndex,
      })
      .subscribe();
  }

  public showAddingToTripSuccess(index) {
    this.isAddingSuccess = [];
    this.trips.forEach((x) => {
      this.isAddingSuccess.push(false);
    });
    this.isAddingSuccess[index] = true;
    setTimeout(() => {
      this.isAddingSuccess[index] = false;
      this.menuTrigger.closeMenu();
    }, 1000);
    setTimeout(() => {
      this.menuTrigger.closeMenu();
    }, 900);
  }

  public addNewTrip() {
    this.isAddingNewTrip = true;
    setTimeout(() => {
      this.tripTitle.focus();
    });
  }

  public checkIsInAnyTrip() {
    this.trips = this.loadTripsInLocalStorage();
    if (!this.trips || !this.trips.length) {
      return false;
    }
    this.isInAnyTrip = false;
    this.trips.forEach((trip) => {
      if (trip.attractions.any((x) => x.item.id === this.item.id)) {
        this.isInAnyTrip = true;
      }
    });
  }

  public openTripMenu() {
    this.trips = this.loadTripsInLocalStorage();
    this.getInTripStatus();
    if (!this.trips || !this.trips.length) {
      this.onAddFirstTrip.emit({ item: this.item, type: this.type });
      return;
    }
    this.trips.forEach((x) => {
      this.isAddingSuccess.push(false);
    });
    this.menuTrigger.openMenu();
  }

  public createNewTrip(title?, addThisItem?, type?, callback?) {
    let attractions = [];
    if (addThisItem) {
      attractions.push({ feedId: addThisItem._id, feedType: type, order: 1 });
    }
    if (SocialLoginPopupComponent.isUserLoggedIn) {
      this.visitorApiService
        .createTrip(this.hubName, {
          id: guid(),
          userFacebookId: SocialLoginPopupComponent.userId,
          description: '',
          hubName: this.hubName,
          newTrip: { id: guid(), title: title || this.newTripTitle, img: null, attractions: attractions },
          trips: [],
        })
        .subscribe(() => {});
    }
    this.trips = this.addNewTripToLocalStorage(title || this.newTripTitle, addThisItem, type).trips;
    this.checkIsInAnyTrip();
    this.notifyAddOrRemoveItemStore.notifyCommand.next(null);
    if (callback) {
      callback();
    }
  }

  public addNewTripToLocalStorage(title, item?, type?) {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(
      this.hubName,
      SocialLoginPopupComponent.userId
    );
    let trips = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
    let newTrip = new CreateTripCommand();
    if (!trips || !trips.trips || !trips.trips.length) {
      trips = new TripStorageCommand();
    } else {
      if (trips.trips.length >= config.tripPlanner.maxTripCount) {
        return;
      }
    }
    newTrip.attractions = [];
    if (item) {
      newTrip.attractions.push({
        feedType: type,
        feedId: item._id,
        order: 1,
        item: item,
      });
    }
    newTrip.title = title;
    newTrip.timestamp = new Date();
    newTrip.hubName = this.hubName;
    newTrip.img = null;
    trips.trips.push(newTrip);

    let tripsWithUserId = clone(trips);
    localStorage.setItem(key, JSON.stringify(trips));
    tripsWithUserId.userFacebookId = SocialLoginPopupComponent.userId || null;
    localStorage.setItem(keyWithUserID, JSON.stringify(tripsWithUserId));

    return trips;
  }

  public addToLocalStorage(item, tripIndex?) {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(
      this.hubName,
      SocialLoginPopupComponent.userId
    );
    let trip = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
    if (!trip || !trip.trips) {
      return;
    }

    if (tripIndex >= trip.trips.length) {
      return;
    }

    trip.trips[tripIndex].attractions = trip.trips[tripIndex].attractions.removeDuplicate();

    trip.trips[tripIndex].attractions.push({
      feedType: item.startTime ? 'event' : 'place',
      feedId: item._id,
      order: trip.trips[tripIndex].attractions.length,
      item: item,
    });
    trip.trips[tripIndex].attractions = trip.trips[tripIndex].attractions.removeDuplicate();
    trip.trips[tripIndex].timestamp = new Date();
    trip.trips[tripIndex].updateTime = new Date();
    trip.updateTime = new Date();
    trip.trips[tripIndex].hubName = this.hubName;
    localStorage.setItem(key, JSON.stringify(trip));
    trip.userFacebookId = SocialLoginPopupComponent.userId || null;
    localStorage.setItem(keyWithUserID, JSON.stringify(trip));
  }

  private loadTripsInLocalStorage() {
    let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
    let trips = JSON.parse(localStorage.getItem(key)) as TripStorageCommand;
    if (!trips || !trips.trips || !trips.trips.length) {
      trips = new TripStorageCommand();
    }
    return trips.trips;
  }

  private getItemType() {
    return this.item.startTime ? 'event' : 'place';
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/add.to.trip.menu/visitor.trip.add.to.trip.menu.component.ts